export default {
    histories: [],
}
